import ProgressBase, { ProgressBarBaseProps } from "../ProgressBase";

export interface VLProgressBarProps
  extends Omit<ProgressBarBaseProps, "fillPercent"> {
  maxItems: number;
  itemLength: number;
  color?: "danger" | "warning" | "success" | "default";
}

export default function VLProgressBar({
  itemLength,
  maxItems,
  color,
  isActive,
  type,
}: VLProgressBarProps) {
  const percent = (itemLength / maxItems) * 100;
  const colorMap = {
    danger: "var(--primary-accent-color-error)",
    warning: "var(--primary-accent-color-warning)",
    success: "var(--primary-accent-color-success)",
  };

  const strokeColor = color
    ? colorMap[color as keyof typeof colorMap]
    : undefined;
  return (
    <ProgressBase
      fillPercent={percent}
      strokeColor={strokeColor}
      isActive={isActive}
      type={type}
    />
  );
}
